/**
 * @file
 * Patria megamenu functionality
 */

(function ($, Drupal) {

  'use strict';

  var timers = {};

  /**
   * Initializes the menu.
   *
   * @param      {object}  menuItems  Menu items.
   */
  var initMenuItems = menuItems => {

    menuItems.forEach((el, i) => {
      var button = el.querySelector('button');
      var parent = el.parentNode;

      if (el.classList.contains('menuparent')) {
        closeOnEscKey(el);
      }

      el.addEventListener('mouseenter', (e) => {
        closeSubmenus(el, parent);
        toggleElement(el, true);

        // Clear the timeout if the user made a mistake (i.e. accidently hovered outside element)
        clearTimeout(timers[i]);
      });
      el.addEventListener('mouseleave', (e) => {
        // Add a small delay for exiting the submenu with hover events.
        timers[i] = setTimeout(function (e) {
          toggleElement(el, false);
        }, 500);
      });

      // Click handlers for submenu buttons.
      button.addEventListener('click', (e) => {
        if (!getAriaState(button)) {
          closeSubmenus(el, parent);
          toggleElement(el, true);
        }
        else {
          toggleElement(el, false);
        }
        e.preventDefault();
        return false;
      });
    });

  };

  /**
   * Get current ARIA state for given element.
   *
   * @param      {object}  el      DOM element.
   *
   * @return     {boolean}  ARIA-expanded state.
   */
  var getAriaState = el => {
    return el.getAttribute('aria-expanded') === 'true';
  };

  /**
   * Toggle visibility for element's submenu.
   *
   * @param      {object}   el       DOM element.
   * @param      {boolean}  toState  Aria-expanded state.
   */
  var toggleElement = (el, toState) => {
    let link = el.querySelector('a');
    if (link) {
      link.setAttribute('aria-expanded', toState);
    }
    el.querySelector('button').setAttribute('aria-expanded', toState);
    if (toState === true) {
      el.classList.add('open');
    }
    else {
      el.classList.remove('open');
    }
  };

  /**
   * Close submenus for given context.
   *
   * @param      {object}  el      DOM element.
   * @param      {object}  parent  DOM element.
   */
  var closeSubmenus = (el, parent) => {
    if (el.classList.contains('menuparent')) {
      var context = document;
    }
    else {
      var context = parent;
    }
    context.querySelectorAll('.menuparent.open').forEach(elem => {
      // Ensure nested submenus don't get closed
      if (!el.contains(elem)) {
        toggleElement(elem, false);
      }
    });
  };

  /**
   * Close submenu on ESC keypress.
   *
   * @param      {object}  el  DOM element.
   */
  var closeOnEscKey = (el) => {
    el.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        let focusButton = el.querySelector('button');
        toggleElement(el, false);

        if (focusButton) {
          focusButton.focus();
        }
      }
    });
  };

  Drupal.behaviors.megamenu = {
    attach: () => {

      const menuParentWrappers = ".naviagtion-wrapper .sf-menu li.sf-depth-1 > ul > .parent-wrapper";

      $(menuParentWrappers).each(function () {

        // Add child count classes to megamenu for different styles
        $(this).parent().addClass("child-count-" + $(this).children().length);

        // If there is only second level links on megamenu submenu, add class for different styles
        if ($(this).find(".sf-depth-3").length == 0) {
          $(this).parent().addClass("only-level-2");

          // Copy level 1 menu link to first child of submenu
          $(this).prepend("<li class='duplicate-parent sf-depth-2'></li>");
          $(this).parent().siblings("a").clone().appendTo($(this).find(".duplicate-parent"));
        }
      });

      // Add class to menu image parent li:s
      $('.naviagtion-wrapper .sf-menu .media--view-mode-menu-image').each(function () {
        $(this).parent().addClass("is-menu-image");
      });

      // Add class to menu highlight parent-wrappers
      $('.naviagtion-wrapper .sf-menu .megamenu-highlight').each(function () {
        $(this).parent().parent().addClass("has-menu-highlight");
      });

      // Accessibility
      let menuItems = document.querySelectorAll('.naviagtion-wrapper li.sf-depth-1.menuparent');
      if (menuItems) {
        initMenuItems(menuItems);
      }

    }
  };

})(jQuery, Drupal);